import apiFetch from '../../apiFetch'

export default function (idIntervencion, token) {
  return apiFetch({endPoint: `Intervencion/imprimirDetalleRegistroIntervencion?idIntervencion=` + idIntervencion, method: 'GET', body: null, token: token})
}